module.exports = __webpack_public_path__ + "static/media/poweredbyStripe.8576e609.png";